<template>
  <!-- Main -->
  <div id="main" v-if="initialized">
    <!-- 紀錄 -->
    <div id="mainRecord">
      <div class="areaH">
        <div class="areaV">
          <div class="box" style="position: relative;">
            <span class="title">紀錄</span>
            <el-tag
              v-for="(resourceName, index) in filterCodes"
              :key="'resourceName' + index"
              closable
              :disable-transitions="false"
              effect="plain"
              size="medium"
              type="warning"
              @close="resetFilter()"
              >{{ resourceName }}
            </el-tag>
            <el-tag
              v-for="(actionName, index) in filterActions"
              :key="'actionName' + index"
              closable
              :disable-transitions="false"
              effect="plain"
              size="medium"
              type="warning"
              @close="resetFilter()"
              >
              {{ actionName }}
            </el-tag>
            <table>
              <tr>
                <th><span class="content">#</span></th>
                <th><span class="content">修改者</span></th>
                <th><span class="content">分類</span></th>
                <th><span class="content">項目</span></th>
                <th><span class="content">動作</span></th>
                <th><span class="content">內容</span></th>
                <th><span class="content">修改時間</span></th>
              </tr>
              <tr v-for="(record, index) in records" :key="'record' + index">
                <td align="center">
                  <span class="content">{{ index + 1 }}</span>
                </td>
                <td align="center">
                  <span class="content">{{ record.userName }}</span>
                </td>
                <td align="center">
                  <span class="content">{{ record.consoleType }}</span>
                </td>
                <td align="center">
                  <span class="content"
                    >{{ record.displayName }}
                    <a
                      v-show="!filterMode"
                      @click="
                        filterByResourceCode(
                          record.resourceCode,
                          record.displayName
                        )
                      "
                      ><FontAwesomeIcon icon="filter"
                    /></a>
                  </span>
                </td>
                <td align="center">
                  <span class="content"
                    >{{ displayAction(record.action) }}
                    <a
                      v-show="!filterMode"
                      @click="filterByAction(record.action, record.action)"
                      ><FontAwesomeIcon icon="filter"
                    /></a>
                  </span>
                </td>
                <td align="center">
                  <span class="content">{{ record.displayLog }}</span>
                </td>
                <td align="center">
                  <span class="content">{{
                    convertTimestamp(record.timestamp)
                  }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchRecord,
  fetchRecordResourceCode,
  fetchRecordAction
} from "src/javascripts/gaa/fetchForConsoleLog";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment-timezone";
import { Tag } from "element-ui";

export default {
  components: {
    FontAwesomeIcon,
    [Tag.name]: Tag
  },
  data() {
    return {
      records: [],
      data: [],
      initialized: false,
      filterMode: false,
      filterCodes: [],
      filterActions: []
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    initialize: {
      type: Boolean,
      default: false
    }
  },
  created: function() {
    // fetch value
    console.log("created!!");
    fetchRecord(this.accountId)
      .then(fetchRecordRes => {
        if (fetchRecordRes.data.length > 0) {
          this.setData(fetchRecordRes.data);
        } else {
          throw new Error("FetchData error!");
        }
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });
  },
  mounted() {
    console.log("mounted!!");
  },
  methods: {
    setData(fetchData) {
      fetchData.forEach((data, index) => {
        this.$set(this.records, index, data);
      });
      this.initialized = true;
    },
    convertTimestamp(timestamp) {
      return moment.unix(timestamp)
        .format("YYYY-MM-DD HH:mm:ss");
    },
    filterByResourceCode(resourceCode, resourceName) {
      this.filterMode = true;
      let that = this;
      fetchRecordResourceCode(this.accountId, resourceCode)
        .then(fetchRecordResourceRes => {
          let fetchData = fetchRecordResourceRes.data;
          that.records = [];
          fetchData.forEach((data, index) => {
            that.$set(that.records, index, data);
          });
          this.filterCodes.push(resourceName);
        })
        .catch(fetchRecordResourceErr => {
          console.log("fetchRecordResourceErr: ", fetchRecordResourceErr);
        });
    },
    filterByAction(action, actionName) {
      this.filterMode = true;
      let that = this;
      fetchRecordAction(this.accountId, action)
        .then(fetchRecordActionRes => {
          let fetchData = fetchRecordActionRes.data;
          that.records = [];
          fetchData.forEach((data, index) => {
            that.$set(that.records, index, data);
          });
          this.filterActions.push(that.displayAction(actionName));
        })
        .catch(fetchRecordActionErr => {
          console.log("fetchRecordActionErr: ", fetchRecordActionErr);
        });
    },

    resetFilter() {
      this.filterMode = false;
      this.filterCodes = [];
      this.filterActions = [];
      fetchRecord(this.accountId)
        .then(fetchRecordRes => {
          if (fetchRecordRes.data.length > 0) {
            this.setData(fetchRecordRes.data);
          } else {
            throw new Error("FetchData error!");
          }
        })
        .catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法取得資料！`
          });
        });
    },
    displayAction(action) {
      var displayActionName = action;
      switch (action) {
        case "create":
          displayActionName = "新增/建立";
          break;
        case "update":
          displayActionName = "更新/修改";
          break;
        case "delete":
          displayActionName = "刪除";
          break;
        default:
          break;
      }
      return displayActionName;
    }
  },
    watch: {
      initialize: function(newVal, oldVal) {
        console.log("initialize: ", newVal, oldVal)
        fetchRecord(this.accountId)
        .then(fetchRecordRes => {
          if (fetchRecordRes.data.length > 0) {
            this.setData(fetchRecordRes.data);
          } else {
            throw new Error("FetchData error!");
          }
        })
        .catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法取得資料！`
          });
        });
      }
    }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
